import { adminHttpClient } from '../../../../commons/adminHttpClient'

export interface ProductClassDesignSummaryResponse {
  id: string
  name: string
  classType: {
    id: number
    name: string
  }
  offerSameAllowance: boolean
  waitingPeriod: number
  prorateAllowancesHire: boolean
  prorateAllowancesTerminate: boolean
  designCompleted: boolean
  reimburseAnotherEmployeePlan: boolean
  reimbursementProduct: {
    id: number
    name: string
  }
  requiresEOB: boolean
  requiresPrescription: boolean
  deductable: boolean
  eeDeductableAmount: number
  eeCoinsurance: boolean
  eobExpense: [
    {
      id: number
      name: string
    },
  ]
  familyAgeAllowances: {
    age: number
    marriedAmount: number
    singleAmount: number
    marriedWithDependentsAmount: number
    singleWithDependentsAmount: number
  }[]
  familyAllowances: [
    {
      familyId: number
      familyName: string
      amount: number
    },
  ]
  nextFamilyAllowances: [
    {
      familyId: number
      familyName: string
      amount: number
    },
  ]
  familyDeductibles: [
    {
      familyId: number
      familyName: string
      deductible: number
    },
  ]
  familyCostSharings: [
    {
      familyId: number
      familyName: string
      costSharing: number
    },
  ]
}

export type FamilyAgeAllowance = {
  age: number
  marriedAmount: number
  singleAmount: number
  marriedWithDependentsAmount: number
  singleWithDependentsAmount: number
}

export interface EligibleExpenseCategory {
  expenseCategoryId: number
  expenseCategoryName: string
  allowance: number
  eligibleExpenseTypes: EligibleExpenseType[]
}

export interface EligibleExpenseType {
  id: number
  name: string
}

const getProductClassDesignSummary = (productClassId: string): Promise<ProductClassDesignSummaryResponse> => {
  return adminHttpClient.get(`/Benefit/ProductClassHraDetails/${productClassId}`)
}

export default getProductClassDesignSummary
